import Balance from "../../pages/components/Balance";
import DrawResult from "./bet/DrawResult";
import _ from "lodash";
import RecentOrdering from "./RecentOrdering";
import RecentBetting from "./bet/RecentBetting";
import React from "react";

const LeftSide = (props) => {
    const {user: {userBalance, isAddToCart}, betting} = props;
    return <div className="border">
        <div>
            <Balance pendingAmount={userBalance.pendingRoulette}/>
        </div>
        <div>
            <DrawResult {...props}/>
        </div>
        <div>
            {(!_.isEmpty(betting.betList) && isAddToCart) &&
            <RecentOrdering {...props}/>}
        </div>
        <div>
            <RecentBetting {...props}/>
        </div>
    </div>
}

export default LeftSide